function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import AgreementsComponent from '@/components/AgreementsComponent.vue';
import TokenComponent from '@/components/TokenComponent.vue';
import SecurityService from '@/apps/data-platform/services/security/user_security_service';
import tasks from '@/js/tasks';
import { firebaseConfig, GA_EVENTS, ROLES_LIST } from '@/js/constants';
import { mapState } from 'vuex';
import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
export default {
  name: 'Somos1ReportListPage',
  components: {
    AgreementsComponent: AgreementsComponent,
    TokenComponent: TokenComponent
  },
  data: function data() {
    return {
      keyDashboardsList: 0,
      items: [],
      headers: [{
        value: 'report.name',
        text: 'Nombre'
      }, {
        value: 'report.description',
        text: 'Descripcion'
      }, {
        value: 'report.region.region',
        text: 'Region'
      }, {
        value: 'actions',
        text: ''
      }],
      send_token: false,
      has_accepted: userInfo.somos1_agreement,
      agreement_text: '',
      color: 'custom',
      decline: false,
      canDownload: false,
      filter_enabled: false,
      filtro: {
        isGeneral: false
      },
      valid: true,
      filterOptions: ['Todos', 'Zonal', 'Interzonal'],
      selectedFilter: 'Todos'
    };
  },
  created: function created() {
    var _this = this;
    var params_ = {
      'email': userInfo.email,
      'domain': userInfo.domain
    };
    Somos1Service.somos1_has_accepted_agreement(params_).then(function (response) {
      _this.has_accepted = response.data;
      if (!_this.has_accepted) {
        console.log('created', _this.has_accepted);
        _this.openAgreement();
      }
    });
    if (window.userInfo.userRoles.includes(ROLES_LIST.INSIGHTS_ADMIN) || window.userInfo.userRoles.includes(ROLES_LIST.INSIGHTS_USER_SOMOS1)) {
      this.canDownload = true;
    }
    this.getReports();
  },
  mounted: function mounted() {
    var _this2 = this;
    Somos1Service.somos1_agreement().then(function (response) {
      _this2.agreement_text = response.data;
    });

    // /if (!userInfo.somos1_agreement) {
    // /console.log('mounted', !userInfo.somos1_agreement)
    // /this.openAgreement()
    // /}
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    filteredItems: function filteredItems() {
      var _this3 = this;
      if (!this.selectedFilter || this.selectedFilter === 'Todos') {
        return this.items;
      }
      return this.items.filter(function (item) {
        return item.report.tags.includes(_this3.selectedFilter);
      });
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.customer.home'),
        disabled: false,
        href: '/#/customer_insights/home'
      }, {
        text: this.translate('menu.customer.somos1'),
        disabled: false,
        href: '/#/customer_insights/somos1_home'
      }, {
        text: this.translate('menu.customer.somos1_reports'),
        disabled: false,
        href: '/#/customer_insights/somos1'
      }, {
        text: 'insights',
        disabled: true,
        href: ''
      }];
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), mapState('app', ['menuSelected'])), {}, {
    getReports: function getReports() {
      var _this4 = this;
      console.log('entrando a reports');
      this.setShowLoading(true);
      var params = {
        is_admin: this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN),
        has_accepted: this.has_accepted,
        section: 'Somos1'
      };
      Somos1Service.getReportsAssignments(params).then(function (response) {
        var otrosReportes = [];
        response.data.forEach(function (item) {
          var report = item.report;
          var tags = report.tags;
          if (Array.isArray(tags) && !tags.includes('Visitas') && !tags.includes('Métricas')) {
            otrosReportes.push(item);
          }
        });

        // response.data = response.data.filter(item => item.report.section === 'Somos1')
        _this4.items = otrosReportes;
        _this4.filteredItems = _this4.items; // Agregar esta línea
        _this4.keyDashboardsList += 1;
      }).finally(function () {
        _this4.setShowLoading(false);
      });
    },
    openAgreement: function openAgreement() {
      this.$refs.agreement.onOpen();
    },
    onVolver: function onVolver() {
      this.decline = false;
      this.openAgreement();
    },
    onAccept: function onAccept() {
      var _this5 = this;
      this.$refs.agreement.onClose();
      var token = this.genToken();
      var data = {
        'token': token,
        'email': userInfo.email,
        'domain': userInfo.domain
      };
      SecurityService.sendToken(data).then(function (response) {
        _this5.$refs.tokencomponent.onOpen();
      });
    },
    onClose: function onClose() {
      this.decline = true;
    },
    sendToken: function sendToken(token) {
      var _this6 = this;
      var data = {
        'token': token,
        'email': userInfo.email,
        'domain': userInfo.domain
      };
      SecurityService.verifyToken(data).then(function (response) {
        if (!response.data) {
          tasks.toast.error('Token incorrecto, ingréselo nuevamente.');
        } else {
          tasks.toast.success('Token correcto.');
          _this6.$refs.tokencomponent.onClose();
          _this6.userInfo.somos1_agreement = true;
          _this6.has_accepted = true;
          location.reload();
          _this6.getReports();
        }
      });
    },
    onVer: function onVer(item) {
      console.log(this.menuSelected);
      var roles = this.userInfo.userRoles;
      var encontradoUser = roles.includes('insights_user_somos1');
      var encontradoBusiness = roles.includes('insights_business_user');
      var rol = encontradoUser ? encontradoBusiness ? 'insights_user_somos1' : 'insights_user_somos1' : encontradoBusiness ? 'insights_business_user' : null;
      console.log('rol:', rol);
      var report = item.report;
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: GA_EVENTS.CLICK_REPORT,
          region: _typeof(report.region) === 'object' ? report.region.region : report.region,
          type: 'somos1_report',
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          rol: rol,
          'module': 'customer_insights',
          report_id: item.report_id
        });
      }
      this.openReport(item);
    },
    openDictionary: function openDictionary() {
      this.$router.push({
        path: '/customer_insights/dashboards/dictionary'
      });
    },
    onDownload: function onDownload(item) {
      var _this7 = this;
      var params = {
        'id_region_dataentry': item.report.region.id_region_dataentry,
        'region': item.report.region.region
      };
      Somos1DataEntryService.postDownloadDataByRegion(params).then(function (response) {
        if (response) {
          var url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }));
          var link = document.createElement('a');
          link.href = url;
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
          var filename = 'dataentry-' + date + '-' + time + '.xlsx';
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          _this7.loading = false;
          var roles = _this7.userInfo.userRoles;
          var encontradoUser = roles.includes('insights_user_somos1');
          var encontradoBusiness = roles.includes('insights_business_user');
          var rol = encontradoUser ? encontradoBusiness ? 'insights_user_somos1' : 'insights_user_somos1' : encontradoBusiness ? 'insights_business_user' : null;
          console.log('rol:', rol);
          var report = item.report;
          if (_this7.$gtm.enabled() && window.dataLayer) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: GA_EVENTS.DOWNLOAD_REPORT,
              region: _typeof(report.region) === 'object' ? report.region.region : report.region,
              type: 'somos1_report',
              company_code: _this7.companyCode,
              hash_email: _this7.stringToHash(userInfo.email),
              rol: rol,
              'module': 'customer_insights',
              report_id: item.report_id
            });
          }
        }
      });
    },
    openReport: function openReport(item) {
      this.$router.push({
        name: 'Somos1',
        params: {
          report_id: item.report.document_id,
          no_require_agreement: false,
          link: 'somos1',
          title: 'Somos 1'
        }
      });
    },
    genToken: function genToken() {
      var token = Math.floor(Math.random() * 9000) + 1000;
      return token.toString();
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    applyFilter: function applyFilter() {
      var _this8 = this;
      if (!this.selectedFilter || this.selectedFilter === 'Todos') {
        this.filteredItems = this.items;
      } else {
        this.filteredItems = this.items.filter(function (item) {
          return item.report.tags.includes(_this8.selectedFilter);
        });
      }
    },
    onCleanSearch: function onCleanSearch() {
      this.selectedFilter = 'Todos';
      this.applyFilter();
    }
  })
};